import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, useTransform, useScroll } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

const TitleContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5; // Sous la transition mais au-dessus du contenu normal
  pointer-events: none;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  pointer-events: auto;
`;

const Title = styled(motion.h1)`
  font-size: clamp(4rem, 15vw, 12rem);
  font-weight: 700;
  color: #333;
  line-height: 1;
  letter-spacing: -2px;
  transition: transform 0.3s ease;
  mix-blend-mode: difference;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
  
  &:hover {
    transform: scale(1.03);
  }
`;

const MainTitle = () => {
  const { t } = useTranslation();
  const { scrollY } = useScroll();
  const [shouldRender, setShouldRender] = useState(false);
  const location = useLocation();
  
  const titleY = useTransform(scrollY, [0, 500], [0, -100]);
  const titleOpacity = useTransform(scrollY, [0, 300, 500], [1, 0.5, 0]);
  const titleScale = useTransform(scrollY, [0, 300], [1, 0.8]);

  // Effet pour l'apparition du titre lorsqu'on arrive sur la page d'accueil
  useEffect(() => {
    if (location.pathname === '/') {
      // Petit délai pour laisser la transition de page se terminer
      const timer = setTimeout(() => {
        setShouldRender(true);
      }, 600);
      
      return () => clearTimeout(timer);
    } else {
      setShouldRender(false);
    }
  }, [location.pathname]);

  // Gestion du défilement
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setShouldRender(false);
      } else if (location.pathname === '/') {
        setShouldRender(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  // Ne rendre que sur la page d'accueil
  if (location.pathname !== '/') {
    return null;
  }

  if (!shouldRender) {
    return null;
  }

  return (
    <TitleContainer 
      style={{ 
        y: titleY, 
        opacity: titleOpacity,
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, ease: "easeOut" }}
    >
      <StyledLink to="/">
        <Title
          style={{
            scale: titleScale
          }}
        >
          {t('home.studioName')}
        </Title>
      </StyledLink>
    </TitleContainer>
  );
};

export default MainTitle;